import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './useAuth';
import { trackPublishToSocialClick } from './userJourneyTracker';
import './PublishToSocialBar.css';

const PUBLIC_URL = process.env.PUBLIC_URL || '';

const SOCIAL_ICONS = [
  { src: `${PUBLIC_URL}/instagram.svg`, alt: 'Instagram' },
  { src: `${PUBLIC_URL}/YouTube.svg`, alt: 'YouTube' },
  { src: `${PUBLIC_URL}/linkedin.svg`, alt: 'LinkedIn' },
  { src: `${PUBLIC_URL}/Facebook.png`, alt: 'Facebook' },
];

function RocketIcon() {
  return (
    <svg
      className="publish-social-bar__rocket"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function PublishToSocialBar({ onRequireAuth }) {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  return (
    <div className="publish-social-bar-wrap">
      <button
        type="button"
        className="publish-social-bar"
        aria-label="Publish to Social"
        onClick={() => {
          trackPublishToSocialClick();
          if (!isAuthenticated) {
            onRequireAuth?.();
            return;
          }
          navigate('/calender');
        }}
      >
        <span className="publish-social-bar__left">
          <RocketIcon />
          <span className="publish-social-bar__label">Publish to Social</span>
        </span>
        <span className="publish-social-bar__divider" aria-hidden="true" />
        <span className="publish-social-bar__icons">
          {SOCIAL_ICONS.map(({ src, alt }) => (
            <img
              key={alt}
              src={src}
              alt=""
              className="publish-social-bar__icon"
              width={20}
              height={20}
              aria-hidden="true"
            />
          ))}
        </span>
      </button>
    </div>
  );
}
